import { Box, Skeleton, Tooltip, Typography, useTheme } from '@mui/material';
import React from 'react';
import { tokens } from '../../../global/theme/tokens';
import useFetch from '../../../api/useFetch';
import UserStack from '../UserStack';
import { useTranslation } from 'react-i18next';
import { renderHours } from '../../../scenes/time-tracking/worktime';

export const CHROverview = ({ projectId }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode, theme.palette.colorTheme);

  const { t } = useTranslation();

  const { apiData } = useFetch(`projects/${projectId}/wage-presets`);
  if (!apiData || apiData?.data.length === 0) return;
  return (
    <Box
      className="px-2 py-2 pt-2 rounded-lg mt-4 backdrop-blur-lg"
      sx={{ bgcolor: colors.glass }}
    >
      <Box className="h-[108px] max-h-[108px] flex flex-col gap-[2px] overflow-y-scroll">
        {apiData && apiData.data.length > 0 ? (
          apiData?.data.map((chr) => (
            <Box
              className="flex justify-between items-center px-2 py-[2px] h-[36px]"
              sx={{
                backgroundColor: colors.bgInput,
                borderRadius: 3,
                borderLeft: `7px solid ${chr.color}`,
                borderRight: '0px solid transparent',
              }}
            >
              <Box className="flex gap-1 items-center">
                {chr.image && (
                  <img
                    className="w-[32px] h-[32px] object-contain"
                    src={chr.image.temporaryUrl}
                  />
                )}
                <Typography className="min-w-[100px]">{chr.label}</Typography>
              </Box>

              <Box className="flex items-center">
                <Box className="pr-2">
                  <UserStack users={chr.users || []} />
                </Box>
                <Tooltip title={t('Worked time')}>
                  <Typography fontWeight={600}>
                    {renderHours(chr.workedTimeSeconds / 60) + 'h'}
                  </Typography>
                </Tooltip>
                <Typography className="px-[3px]">{'/'}</Typography>
                <Tooltip title={t('Planned time')}>
                  <Typography fontWeight={600}>
                    {renderHours(chr.plannedTimeSeconds / 60) + 'h'}
                  </Typography>
                </Tooltip>
                <Typography className="pl-1">
                  {`(${
                    chr.plannedTimeSeconds != 0
                      ? Math.round(
                          (chr.workedTimeSeconds / chr.plannedTimeSeconds) * 100
                        )
                      : 0
                  }%)`}
                </Typography>
              </Box>
            </Box>
          ))
        ) : (
          <Box className="flex justify-center items-center h-full">
            <Typography className="opacity-80">
              {t('No Calculative Hourly Rates found')}
            </Typography>
          </Box>
        )}
      </Box>
    </Box>
  );
};
